module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-backdrop.fc820694.jpg";